export const onboardingSteps = [
  {
    id: 'welcome',
    stage: 1,
    order: 1,
    estimatedMinutes: 10,
    titleEN: 'Welcome to GFI',
    titleES: 'Bienvenido a GFI',
    descriptionEN: 'Meet your support team and understand your first-week plan.',
    descriptionES: 'Conoce a tu equipo de apoyo y entiende tu plan de la primera semana.',
    whyEN: 'A clear starting point helps you feel supported from day one. You will know who to contact and what comes next.',
    whyES: 'Un inicio claro te ayuda a sentirte acompañado desde el primer día. Sabrás a quién contactar y qué sigue.',
    requirementsEN: ['Review your welcome message', 'Save your recruiter contact', 'Confirm your preferred language'],
    requirementsES: ['Revisa tu mensaje de bienvenida', 'Guarda el contacto de tu reclutador', 'Confirma tu idioma preferido'],
    resources: [
      {titleEN: 'Associate welcome guide', titleES: 'Guía de bienvenida para asociados', descriptionEN: 'A quick overview of your first week.', descriptionES: 'Un resumen rápido de tu primera semana.', url: 'https://example.com', language: 'Both'}
    ],
    relatedVideoIds: ['video-001']
  },
  {
    id: 'profile',
    stage: 1,
    order: 2,
    estimatedMinutes: 8,
    titleEN: 'Complete your profile',
    titleES: 'Completa tu perfil',
    descriptionEN: 'Confirm your contact details and country information.',
    descriptionES: 'Confirma tus datos de contacto e información de país.',
    whyEN: 'Accurate profile details help your support team reach you quickly. They also keep your onboarding records organized.',
    whyES: 'Los datos correctos ayudan a tu equipo de apoyo a contactarte rápidamente. También mantienen organizados tus registros de incorporación.',
    requirementsEN: ['Confirm your email address', 'Add your phone number', 'Verify your country'],
    requirementsES: ['Confirma tu correo electrónico', 'Agrega tu número de teléfono', 'Verifica tu país'],
    resources: [],
    relatedVideoIds: []
  },
  {
    id: 'orientation',
    stage: 1,
    order: 3,
    estimatedMinutes: 20,
    titleEN: 'Attend orientation',
    titleES: 'Asiste a la orientación',
    descriptionEN: 'Learn how GFI supports associates, clients, and teams.',
    descriptionES: 'Aprende cómo GFI apoya a asociados, clientes y equipos.',
    whyEN: 'Orientation gives you the shared context needed to begin with confidence. It connects the work ahead to the people you will serve.',
    whyES: 'La orientación te brinda el contexto compartido para empezar con confianza. Conecta el trabajo que sigue con las personas a las que servirás.',
    requirementsEN: ['Watch the orientation video', 'Write down one question for your recruiter'],
    requirementsES: ['Mira el video de orientación', 'Escribe una pregunta para tu reclutador'],
    resources: [],
    relatedVideoIds: ['video-001', 'video-003']
  },
  {
    id: 'licensing',
    stage: 2,
    order: 4,
    estimatedMinutes: 25,
    titleEN: 'Understand your licensing path',
    titleES: 'Entiende tu ruta de licencias',
    descriptionEN: 'Review the licensing process and the deadlines that apply to you.',
    descriptionES: 'Revisa el proceso de licencias y los plazos que aplican para ti.',
    whyEN: 'Licensing requirements vary by location and role. Understanding the path early helps you plan without surprises.',
    whyES: 'Los requisitos de licencia varían según la ubicación y el rol. Entender el proceso temprano te ayuda a planificar sin sorpresas.',
    requirementsEN: ['Review your state or country requirements', 'Note your target licensing date', 'Save the licensing support contact'],
    requirementsES: ['Revisa los requisitos de tu estado o país', 'Anota tu fecha objetivo de licencia', 'Guarda el contacto de apoyo de licencias'],
    resources: [
      {titleEN: 'Licensing site', titleES: 'Sitio de licencias', descriptionEN: 'Check requirements and study resources.', descriptionES: 'Consulta requisitos y recursos de estudio.', url: 'https://example.com', language: 'EN'}
    ],
    relatedVideoIds: ['video-004']
  },
  {
    id: 'documents',
    stage: 2,
    order: 5,
    estimatedMinutes: 15,
    titleEN: 'Prepare required documents',
    titleES: 'Prepara los documentos requeridos',
    descriptionEN: 'Collect the documents needed for your onboarding record.',
    descriptionES: 'Reúne los documentos necesarios para tu expediente de incorporación.',
    whyEN: 'Having documents ready prevents delays when you are ready for the next milestone. Your recruiter can help clarify local requirements.',
    whyES: 'Tener los documentos listos evita retrasos cuando estés preparado para el siguiente hito. Tu reclutador puede aclarar los requisitos locales.',
    requirementsEN: ['Government-issued identification', 'Proof of address', 'Complete required local forms'],
    requirementsES: ['Identificación emitida por el gobierno', 'Comprobante de domicilio', 'Completa los formularios locales requeridos'],
    resources: [
      {titleEN: 'Document checklist', titleES: 'Lista de documentos', descriptionEN: 'Use this checklist while collecting your paperwork.', descriptionES: 'Usa esta lista mientras reúnes tu documentación.', url: 'https://example.com', language: 'Both'}
    ],
    relatedVideoIds: ['video-004']
  },
  {
    id: 'systems',
    stage: 2,
    order: 6,
    estimatedMinutes: 18,
    titleEN: 'Set up your systems',
    titleES: 'Configura tus sistemas',
    descriptionEN: 'Access the tools and support channels you will use every day.',
    descriptionES: 'Accede a las herramientas y canales de apoyo que usarás todos los días.',
    whyEN: 'Your systems are where daily work happens. Setting them up now makes future learning and client support easier.',
    whyES: 'Tus sistemas son donde sucede el trabajo diario. Configurarlos ahora facilita el aprendizaje y el apoyo a clientes.',
    requirementsEN: ['Open the back office', 'Bookmark the carrier portals', 'Save the support channel'],
    requirementsES: ['Abre la oficina administrativa', 'Guarda los portales de proveedores', 'Guarda el canal de apoyo'],
    resources: [],
    relatedVideoIds: ['video-006']
  },
  {
    id: 'training',
    stage: 3,
    order: 7,
    estimatedMinutes: 30,
    titleEN: 'Build your product foundation',
    titleES: 'Construye tu base de productos',
    descriptionEN: 'Complete the essential first lessons for client conversations.',
    descriptionES: 'Completa las lecciones esenciales para conversaciones con clientes.',
    whyEN: 'Product knowledge makes conversations more helpful and confident. These lessons give you a practical foundation before your first meetings.',
    whyES: 'El conocimiento de productos hace que las conversaciones sean más útiles y seguras. Estas lecciones te brindan una base práctica antes de tus primeras reuniones.',
    requirementsEN: ['Watch Financial Foundations', 'Review the client needs framework', 'Practice three discovery questions'],
    requirementsES: ['Mira Fundamentos Financieros', 'Revisa el marco de necesidades del cliente', 'Practica tres preguntas de descubrimiento'],
    resources: [],
    relatedVideoIds: ['video-001', 'video-002', 'video-003']
  },
  {
    id: 'first-meeting',
    stage: 3,
    order: 8,
    estimatedMinutes: 20,
    titleEN: 'Prepare for your first meeting',
    titleES: 'Prepárate para tu primera reunión',
    descriptionEN: 'Use a simple plan to prepare, listen, and follow up.',
    descriptionES: 'Usa un plan sencillo para preparar, escuchar y dar seguimiento.',
    whyEN: 'Preparation lets you focus on the client instead of logistics. A consistent follow-up builds trust from the first conversation.',
    whyES: 'La preparación te permite enfocarte en el cliente en lugar de la logística. Un seguimiento constante genera confianza desde la primera conversación.',
    requirementsEN: ['Review the meeting guide', 'Schedule a practice conversation', 'Prepare your follow-up notes'],
    requirementsES: ['Revisa la guía de reuniones', 'Programa una conversación de práctica', 'Prepara tus notas de seguimiento'],
    resources: [
      {titleEN: 'Client meeting guide', titleES: 'Guía de reuniones con clientes', descriptionEN: 'A practical preparation and follow-up guide.', descriptionES: 'Una guía práctica de preparación y seguimiento.', url: 'https://example.com', language: 'Both'}
    ],
    relatedVideoIds: ['video-003']
  },
  {
    id: 'first-30',
    stage: 3,
    order: 9,
    estimatedMinutes: 15,
    titleEN: 'Plan your first 30 days',
    titleES: 'Planifica tus primeros 30 días',
    descriptionEN: 'Set a simple learning rhythm with your recruiter.',
    descriptionES: 'Establece un ritmo de aprendizaje simple con tu reclutador.',
    whyEN: 'Small, consistent actions create momentum in your first month. A shared plan makes it easier to ask for help when you need it.',
    whyES: 'Las acciones pequeñas y constantes crean impulso en tu primer mes. Un plan compartido facilita pedir ayuda cuando la necesitas.',
    requirementsEN: ['Set a weekly check-in', 'Choose your next learning path', 'Write your first-month goal'],
    requirementsES: ['Programa una reunión semanal', 'Elige tu próxima ruta de aprendizaje', 'Escribe tu meta del primer mes'],
    resources: [],
    relatedVideoIds: ['video-005']
  }
];

export const initialOnboardingProgress = [
  {userId: 'usr-001', stepId: 'welcome', status: 'Done', completedAt: '2025-03-01', requirementsChecked: [0, 1, 2]},
  {userId: 'usr-001', stepId: 'profile', status: 'Done', completedAt: '2025-03-02', requirementsChecked: [0, 1, 2]},
  {userId: 'usr-001', stepId: 'orientation', status: 'Done', completedAt: '2025-03-04', requirementsChecked: [0, 1]},
  {userId: 'usr-001', stepId: 'licensing', status: 'In progress', completedAt: null, requirementsChecked: [0]},
  {userId: 'usr-002', stepId: 'welcome', status: 'Done', completedAt: '2025-02-10', requirementsChecked: [0, 1, 2]},
  {userId: 'usr-002', stepId: 'profile', status: 'Done', completedAt: '2025-02-12', requirementsChecked: [0, 1, 2]},
  {userId: 'usr-003', stepId: 'welcome', status: 'Done', completedAt: '2025-02-05', requirementsChecked: [0, 1, 2]},
  {userId: 'usr-003', stepId: 'profile', status: 'Done', completedAt: '2025-02-07', requirementsChecked: [0, 1, 2]},
  {userId: 'usr-003', stepId: 'orientation', status: 'Done', completedAt: '2025-02-10', requirementsChecked: [0, 1]},
  {userId: 'usr-003', stepId: 'licensing', status: 'Done', completedAt: '2025-02-16', requirementsChecked: [0, 1, 2]},
  {userId: 'usr-003', stepId: 'documents', status: 'Done', completedAt: '2025-02-18', requirementsChecked: [0, 1, 2]},
  {userId: 'usr-003', stepId: 'systems', status: 'Done', completedAt: '2025-02-22', requirementsChecked: [0, 1, 2]},
  {userId: 'usr-004', stepId: 'welcome', status: 'Done', completedAt: '2025-02-01', requirementsChecked: [0, 1, 2]}
];

export const associates = [
  {id: 'usr-001', name: 'Sofía Martínez', country: 'México', recruiter: 'Carlos Rivera', recruiterId: 'usr-002', invitedAt: '2025-02-27'},
  {id: 'associate-002', name: 'Valentina Cruz', country: 'Colombia', recruiter: 'Carlos Rivera', recruiterId: 'usr-002', invitedAt: '2025-03-04'},
  {id: 'associate-003', name: 'Mateo Herrera', country: 'Panamá', recruiter: 'Carlos Rivera', recruiterId: 'usr-002', invitedAt: '2025-03-09'},
  {id: 'associate-004', name: 'Lucía Moreno', country: 'México', recruiter: 'Elena Torres', recruiterId: 'usr-003', invitedAt: '2025-03-01'}
];